var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8425 4.15234C11.5153 4.15234 11.25 4.41761 11.25 4.74484V11.3748C11.25 12.7707 10.1184 13.9023 8.7225 13.9023H4.4625C3.0666 13.9023 1.935 12.7707 1.935 11.3748V4.74484C1.935 4.41761 1.66973 4.15234 1.3425 4.15234C1.01527 4.15234 0.75 4.41761 0.75 4.74484V11.3748C0.770565 13.4313 2.44349 15.0874 4.5 15.0873H8.76C10.8019 15.067 12.4522 13.4167 12.4725 11.3748V4.74484C12.4728 4.58098 12.4053 4.42431 12.2859 4.31205C12.1666 4.19979 12.006 4.14197 11.8425 4.15234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8425 3.08734H1.3425C1.01527 3.08734 0.75 2.82207 0.75 2.49484C0.75 2.16761 1.01527 1.90234 1.3425 1.90234H3.33L4.215 0.942344C4.5533 0.598402 5.01507 0.403976 5.4975 0.402344H7.6875C8.1629 0.402338 8.61884 0.591186 8.955 0.927344L9.855 1.90234H11.8425C12.1697 1.90234 12.435 2.16761 12.435 2.49484C12.435 2.82207 12.1697 3.08734 11.8425 3.08734ZM7.6875 1.58734H5.4975C5.34756 1.5874 5.20308 1.64358 5.0925 1.74484L4.95 1.89484H8.235L8.0925 1.74484C7.98273 1.64229 7.83771 1.5859 7.6875 1.58734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78 5.49484V7.74484C3.78 8.0555 4.03184 8.30734 4.3425 8.30734C4.65316 8.30734 4.905 8.0555 4.905 7.74484V5.49484C4.905 5.18418 4.65316 4.93234 4.3425 4.93234C4.03184 4.93234 3.78 5.18418 3.78 5.49484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03 5.49484V11.4948C6.03 11.8055 6.28184 12.0573 6.5925 12.0573C6.90316 12.0573 7.155 11.8055 7.155 11.4948V5.49484C7.155 5.18418 6.90316 4.93234 6.5925 4.93234C6.28184 4.93234 6.03 5.18418 6.03 5.49484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28 5.49484V7.74484C8.28 8.0555 8.53184 8.30734 8.8425 8.30734C9.15316 8.30734 9.405 8.0555 9.405 7.74484V5.49484C9.405 5.18418 9.15316 4.93234 8.8425 4.93234C8.53184 4.93234 8.28 5.18418 8.28 5.49484Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.a43847c82b36910e4bf44dd010871054.svg";
export { ForwardRef as ReactComponent };